import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VContainer,[_c(VRow,{attrs:{"justify":"center"}},[_c('apexchart',{attrs:{"width":"360","height":"250","type":"bar","options":_vm.chartOptions,"series":_vm.series}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }